/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Loading_InfoInputs */

const en_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading project info... please wait a moment.`)
};

const fr_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des informations du projet... veuillez patienter.`)
};

const de_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinformationen werden geladen... Bitte warten Sie einen Moment.`)
};

const it_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento informazioni sul progetto... attendere un attimo.`)
};

const ru_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка информации о проекте... пожалуйста, подождите немного.`)
};

const es_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando información del proyecto... por favor espere un momento.`)
};

const zh_cn2_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载项目信息……请稍候。`)
};

const ja_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報を読み込んでいます...しばらくお待ちください。`)
};

const hi_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट की जानकारी लोड हो रही है... कृपया थोड़ी देर प्रतीक्षा करें।`)
};

const pt_pt2_iconik_import_status_loading_info = /** @type {(inputs: Iconik_Import_Status_Loading_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando informações do projeto... aguarde um momento.`)
};

/**
* | output |
* | --- |
* | "Loading project info... please wait a moment." |
*
* @param {Iconik_Import_Status_Loading_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_loading_info = /** @type {((inputs?: Iconik_Import_Status_Loading_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Loading_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_loading_info(inputs)
	if (locale === "de") return de_iconik_import_status_loading_info(inputs)
	if (locale === "it") return it_iconik_import_status_loading_info(inputs)
	if (locale === "ru") return ru_iconik_import_status_loading_info(inputs)
	if (locale === "es") return es_iconik_import_status_loading_info(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_loading_info(inputs)
	if (locale === "ja") return ja_iconik_import_status_loading_info(inputs)
	if (locale === "hi") return hi_iconik_import_status_loading_info(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_loading_info(inputs)
	return en_iconik_import_status_loading_info(inputs)
});